import React, { useEffect } from 'react'
import { useMap } from "react-leaflet";
import { useDispatch } from 'react-redux';
import { setNewMapState } from "../../mapSlice";
import L from "leaflet";

const FlyTo = () => {
  const map = useMap();
  const dispatch = useDispatch();

  useEffect(() => {
    const CW_CLIENT = process.env.REACT_APP_CLIENT;
    const CW_PASSWORD = process.env.REACT_APP_CLIENT_PASSWORD;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get('id');
    const extended = urlParams.get('extended');

    if (extended !== 'true') {
      dispatch(setNewMapState({ spanHours: 9 }));
    }

    const fetchCoords = async () => {
      const url = `https://xml.customweather.com/xml?client=${CW_CLIENT}&client_password=${CW_PASSWORD}&product=city_report&id=${id}&format=json`;
      const response = await fetch(url);
      const data = await response.json();
      const lat = data.latitude ? data.latitude : 44.66;
      const lng = data.longitude ? data.longitude : -103.85;
      const zoom = data.latitude ? 9 : 3;

      map.setView(new L.LatLng(lat, lng), zoom);
      console.log(map);
      return;
    }
    fetchCoords();

  }, [map, dispatch])
  return null;
}

export default FlyTo
